var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#1D1D1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#1D1D1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3395 15.1196C28.2601 14.8093 28.0356 14.5752 27.7786 14.503C27.3218 14.3756 25.1042 14.0833 20.4167 14.0833C15.7292 14.0833 13.512 14.3758 13.0534 14.5034C12.7987 14.5742 12.5743 14.8083 12.4939 15.1196C12.3805 15.5617 12.0833 17.4124 12.0833 20.3333C12.0833 23.2542 12.3805 25.105 12.4942 25.5483C12.5732 25.8574 12.7977 26.0915 13.0537 26.1633C13.512 26.2909 15.7292 26.5833 20.4167 26.5833C25.1042 26.5833 27.3218 26.291 27.7799 26.1633C28.0346 26.0925 28.2591 25.8584 28.3395 25.5471C28.4528 25.105 28.75 23.25 28.75 20.3333C28.75 17.4167 28.4528 15.5617 28.3395 15.1196ZM30.3575 14.6023C30.8334 16.4583 30.8334 20.3333 30.8334 20.3333C30.8334 20.3333 30.8334 24.2083 30.3575 26.0644C30.0924 27.0909 29.3188 27.8977 28.3381 28.1704C26.5585 28.6667 20.4167 28.6667 20.4167 28.6667C20.4167 28.6667 14.2785 28.6667 12.4952 28.1704C11.5109 27.894 10.7373 27.0871 10.4758 26.0644C10 24.2083 10 20.3333 10 20.3333C10 20.3333 10 16.4583 10.4758 14.6023C10.7409 13.5758 11.5146 12.7689 12.4952 12.4962C14.2785 12 20.4167 12 20.4167 12C20.4167 12 26.5585 12 28.3381 12.4962C29.3224 12.7727 30.0961 13.5795 30.3575 14.6023ZM18.3334 23.9792V16.6875L24.5834 20.3333L18.3334 23.9792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt_icon.0281bc351ca06b0b61fa65a709bfc140.svg";
export { ForwardRef as ReactComponent };